import Backbone from 'backbone';
import Promise from 'bluebird';
import _ from 'underscore';
import { dateRangeEquals } from '@bingads-webui-universal/primitive-utilities';

// A wrapper to 'component/state/index'
export class DateFilterState {
  constructor({
    simpleFormat = false,
    state,
    // Note: configure which date picker to connect to, for now
    // all the campaign ui features use the global one.
  } = {}) {
    this.state = state;
    _.extend(this, Backbone.Events);
    this.previousRange = null;

    this.simpleFormat = simpleFormat;

    if (window.App && window.App.views && window.App.views.Summary) {
      window.App.views.Summary.bindDateFilterChangeHandler((e, filter) => {
        let dateRange;

        if (this.simpleFormat === true) {
          dateRange = _.pick(filter, 'start', 'end', 'grain');
        } else {
          dateRange = filter;
        }

        if (!dateRangeEquals(_.omit(this.previousRange, 'key'), _.omit(dateRange, 'key'))) {
          // Raise event and send data out.
          this.trigger('changed', { dateRange });
          this.previousRange = dateRange;
        }
      });
    }
  }

  get p$State() {
    return this.state.getPromise('$daterange').then((dateRange) => {
      if (!this.previousRange) {
        this.previousRange = dateRange;
      }
      if (this.simpleFormat === true) {
        const newRange = _.pick(dateRange, 'start', 'end', 'grain');

        return Promise.resolve(newRange);
      }
      return Promise.resolve(dateRange);
    });
  }
}
